import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getNovels } from '../services/api';
import { BookOpen, Clock } from 'lucide-react';

const Novels = () => {
  const [novels, setNovels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNovels();
  }, []);

  const fetchNovels = async () => {
    try {
      const data = await getNovels();
      setNovels(data);
    } catch (error) {
      console.error('Error fetching novels:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-gray-600">Loading...</p>
      </div>
    );
  }

  return (
    <div className="py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-16 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <BookOpen size={32} className="text-gray-900" />
            <h1 className="text-4xl md:text-5xl font-serif text-gray-900">Novels</h1>
          </div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Long-form narratives exploring memory, identity, and the spaces between reality and imagination.
          </p>
        </div>

        <div className="space-y-8">
          {novels.length === 0 ? (
            <div className="text-center py-12 bg-gray-50 border border-gray-200">
              <p className="text-gray-600">No novels available yet. Check back soon!</p>
            </div>
          ) : (
            novels.map((novel) => (
              <Link
                key={novel.id}
                to={`/novel/${novel.id}`}
                className="block border border-gray-200 p-8 hover:border-gray-400 transition-colors bg-white"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <h2 className="text-2xl font-serif text-gray-900 mb-2 hover:text-gray-600 transition-colors">
                      {novel.title}
                    </h2>
                    <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
                      <span className="flex items-center gap-1">
                        <Clock size={14} />
                        {novel.totalChapters} {novel.totalChapters === 1 ? 'chapter' : 'chapters'}
                      </span>
                      <span className={`px-2 py-1 text-xs uppercase tracking-wider ${
                        novel.status === 'completed' 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-blue-100 text-blue-800'
                      }`}>
                        {novel.status}
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  {novel.description}
                </p>
                <div className="mt-6">
                  <span className="text-sm uppercase tracking-wider text-gray-900 hover:text-gray-600 inline-flex items-center gap-2 group">
                    Read Novel
                    <span className="transform group-hover:translate-x-1 transition-transform duration-200">→</span>
                  </span>
                </div>
              </Link>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Novels;
